import { Checkbox, CheckboxProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export interface FormCheckBoxFieldProps
    extends Omit<CheckboxProps, 'value' | 'error' | 'name' | 'defaultValue'>,
        ControllerProps<boolean> {
    children?: React.ReactNode;
}

export const FormCheckboxField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormCheckBoxFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        checked: value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <Checkbox {...props} />;
};
